export default "__VITE_ASSET__CBxnMa0p__"